import React from 'react';
import { NavLink } from 'react-router-dom';
import s from './after-registration-page.module.scss';

export const AfterRegistration = () => {
    return (
        <div className={s.wrapper}>
            <div className={s.card}>
                <h2 className={s.title}>
                    Подтверждение аккаунта
                </h2>
                <p className={s.message}>
                    Спасибо за регистрацию! Для завершения процесса регистрации, пожалуйста, подтвердите ваш аккаунт, перейдя по ссылке в письме, которое мы отправили на вашу электронную почту.
                </p>
                <p className={s.register}>
                    Если вы не видите письма, проверьте папку "Спам" или <NavLink to={'/resend-confirmation'}>отправьте письмо снова</NavLink>.
                </p>
            </div>
        </div>
    );
};